import { Steps } from "antd";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import AnalysisWidget from "../../../../../../Analysis/widget";
import { CloseOutlined } from "@ant-design/icons";
import Style from "./style";

export default function ApplicationStatus() {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.authentication);

  const status = user?.amp?.status;

  const getItems = () => {
    switch (status) {
      case 'declined':
        return [
          {
            title: t('Information Compilation'),
            description: t('Once the application form is submitted the information will be shared with the TIF team.'),
          },
          {
            title: t('Review by The Impact Facility'),
            description: t('The TIF team is reviewing your application and will will revert soon.'),
          },
          {
            title: t('Missing information'),
            description: t('Your application has been rejected. Please contact The Impact Facility for further guidance.'),
            icon: (
              <div className="decline-icon">
                <CloseOutlined />
              </div>
            )
          }
        ];
      default:
    }

    return [
      {
        title: t('Information Compilation'),
        description: t('Once the application form is submitted the information will be shared with the TIF team.'),
      },
      {
        title: t('Review by The Impact Facility'),
        description: t('The TIF team is reviewing your application and will will revert soon.'),
      },
    ];
  }

  const getCurrent = () => {
    switch (status) {
      case 'application':
        return 1;
      case 'declined':
        return 2;
      default:
        return 0;
    }
  };

  return (
    <AnalysisWidget
      title={t('Application Status')}
      className="with-border-header">
      <Style>
        <Steps
          style={{ height: '100%' }}
          direction="vertical"
          current={getCurrent()}
          items={getItems()}
        />
      </Style>
    </AnalysisWidget>
  )
}

